export const storageAlerts = {
	label: "Alertas de inventario",
	description:
		"Configure y gestione alertas de su inventario para no perder ningún movimiento",
	search: "Buscar productos",
	btnAddEmail: "Configurar recepción de alerta",
	btnAddProductAlert: "Agregar alerta para un producto",
	titleAlertPhone: "¡Reciba alertas por su teléfono!",
	descriptionAlertPhone:
		"Ahora puede registrar números de teléfono para recibir las alertas de inventario",
	addEmailModal: {
		title: "Configurar recepción de alertas por email",
		name: "Nombre",
		email: "Email",
		emptyText: "Sin emails registrados",
		phone: "Celular",
		placeholders: {
			name: "Ingrese el nombre",
			email: "Ingrese el email",
			phone: "Ingrese el celular",
		},
	},
	addAlertModal: {
		title: "Agregar nueva alerta",
		selectProduct: "Seleccione el producto",
		storageAlert: {
			label: "Alerta",
			storageIn: "Inventario en",
			below: "abajo de",
		},
		storageCritic: {
			label: "CRÍTICO",
			storage: "Inventario",
			below: "abajo de",
		},
		add: "Crear alerta",
		invalidText:
			"El valor de inventario en alerta no puede ser menor o igual al valor de inventario crítico",
	},
	columns: {
		product: "PRODUCTO",
		storageQuantity: "INVENTARIO ACTUAL",
		storageAlert: {
			label: "ALERTA",
			storageIn: "INVENTARIO EN",
			from: "A PARTIR DE",
		},
		storageCritic: {
			label: "CRÍTICO",
			storage: "INVENTARIO",
			from: "A PARTIR DE",
		},
		actions: "ACCIONES",
	},
	filters: {
		ok: "Ok",
		storageAlert: "Estado de alerta",
		storageCritic: "Estado crítico",
	},
};
